import parse from 'html-react-parser';

export const WysiwygRenderer = (props) => {
    return (
        <div className="dip-wysiwyg">
            {props.content && parse(props.content)}
        </div>
    )
}